<section class="warning-popup" aria-labelledby="warning-title" aria-describedby="warning-message">
  <div class="warning-body">
    <span class="warning-symbol" aria-hidden="true"><i class="pi pi-exclamation-triangle"></i></span>
    <div class="warning-copy">
      <h2 id="warning-title">Warning</h2>
      <p id="warning-message">Do you want to continue?</p>
    </div>
  </div>
  <div class="warning-actions">
    <button class="warning-button" type="button" (click)="close(false)">
      <i class="pi pi-times" aria-hidden="true"></i><span>Cancel</span>
    </button>
    <button class="warning-button warning-accept" type="button" (click)="close(true)">
      <i class="pi pi-check" aria-hidden="true"></i><span>Accept</span>
    </button>
  </div>
</section>